export const primary = '#008000'; // Green
export const onDarkSurfacePrimary = '#90EE90'; // Light Green
